import React, { PropTypes } from 'react'
import classNames from 'classnames'
import { identity } from 'lodash'
import "./StampSwatch.css"

const StampSwatch = ({ stamp, selected, disabled, onClick = identity }) => (
  (stamp && stamp.menuImageUrl) ?
    <div className={classNames({
      'stamp-swatch': true,
      'selected': selected,
      'disabled': disabled,
    })}
      onClick={() => disabled ? "" : onClick(stamp)}
    >
      <img
        src={stamp.menuImageUrl + '&op_colorize=' + ((selected) ? '255,255,255' : (disabled ? '50,50,50' : '150,150,150') )}
        alt={stamp.label}
        title={stamp.label + (disabled ? " (OUT OF STOCK)" : "")}
      />
    </div>
    :
    <span className="no-selection-text"> No Selection </span>
)

StampSwatch.propTypes = {
  stamp: PropTypes.object,
  selected: PropTypes.bool,
  onClick: PropTypes.func, 
}

export default StampSwatch;